var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cost-chart-container"},[(_vm.costTotal > 0)?_c('pieChart',{attrs:{"chartData":_vm.chartData,"options":_vm.options}}):_c('div',{staticClass:"grey--text"},[_vm._v(" 圖表無資料 ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }